import React from 'react';
import { Grid, Typography } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { TemplateLink } from 'utils/link';
import { IndexListItemButton } from 'components/styles_components/list';

const ListItem = ({ template }) => {
  const navigate = useNavigate();

  return (
    <IndexListItemButton
      key={template.id}
      onClick={() => {
        navigate(TemplateLink(template.id));
      }}
    >
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="button">{template.name}</Typography>
        </Grid>
      </Grid>
    </IndexListItemButton>
  );
};

export default React.memo(ListItem);
